import { gql } from 'apollo-angular';

export const GET_WORKFLOWS = gql`
  query ($tenantId: ID!, $types: [String]) {
    workflows(tenantId: $tenantId, types: $types) {
      id
      tenantId
      name
      type
      status
      silenced
      includedSegmentIds
      triggers
      collectorIds
      nodes {
        nodeId
        type
        parameters
        childrenIds
        __typename
      }
    }
  }
`;

export const GET_SLIM_WORKFLOWS = gql`
  query ($tenantId: ID!) {
    workflows(tenantId: $tenantId) {
      id
      name
      type
      status
    }
  }
`;

export const GET_WORKFLOW = gql`
  query ($id: ID!) {
    workflow(id: $id) {
      id
      alias
      name
      type
      status
      silenced
      includedSegmentIds
      triggers
      collectorIds
      bucket {
        start
        finish
      }
      nodes {
        nodeId
        type
        position
        parameters
        childrenIds
        diagram {
          coordinates {
            x
            y
          }
        }
        __typename
      }
    }
  }
`;

export const ADD_WORKFLOW = gql`
  mutation ($input: CreateWorkflowInput!) {
    createWorkflow(input: $input) {
      id
      alias
      tenantId
      name
      type
      status
      silenced
      collectorIds
      triggers
      bucket {
        start
        finish
      }
      includedSegmentIds
    }
  }
`;

export const UPDATE_WORKFLOW = gql`
  mutation ($input: UpdateWorkflowInput!) {
    updateWorkflow(input: $input) {
      id
      alias
      name
      status
      silenced
      includedSegmentIds
      bucket {
        start
        finish
      }
      nodes {
        nodeId
        type
        position
        parameters
        diagram {
          coordinates {
            x
            y
          }
        }
        childrenIds
      }
    }
  }
`;

export const UPDATE_WORKFLOW_NODES = gql`
  mutation ($input: UpdateNodeParametersInput!, $workflowInput: UpdateWorkflowInput!) {
    updateNodeParameters(input: $input, workflowInput: $workflowInput) {
      id
    }
  }
`;

export const GET_WORKFLOW_PRIORITY_BY_TENANT = gql`
  query ($tenantId: ID!) {
    workflowPriorityByTenant(tenantId: $tenantId) {
      tenantId
      workflowIds
      __typename
    }
  }
`;

export const PAUSE_WORKFLOW = gql`
  mutation ($input: PauseWorkflowInput!) {
    pauseWorkflow(input: $input) {
      id
      status
    }
  }
`;

export const RESUME_WORKFLOW = gql`
  mutation ($input: PublishWorkflowInput!) {
    publishWorkflow(input: $input) {
      id
      name
      status
      silenced
      nodes {
        nodeId
        type
        parameters
      }
    }
  }
`;

export const DELETE_WORKFLOW = gql`
  mutation ($id: ID!) {
    deleteWorkflow(id: $id) {
      id
    }
  }
`;

export const UNPUBLISH_WORKFLOW = gql`
  mutation ($input: UnPublishWorkflowInput!) {
    unPublishWorkflow(input: $input) {
      id
      name
      status
      silenced
      nodes {
        nodeId
        type
        parameters
      }
    }
  }
`;

export const GET_WORKFLOW_TRIGGERS = gql`
  query ($tenantId: ID!) {
    workflowTriggers(tenantId: $tenantId) {
      id
      name
      available
    }
  }
`;

export const GET_WORKFLOW_PRIORITY = gql`
  query ($tenantId: ID!) {
    workflowPriorityByTenant(tenantId: $tenantId) {
      tenantId
      workflowIds
    }
  }
`;

export const UPDATE_WORKFLOW_PRIORITY = gql`
  mutation ($input: UpdateWorkflowPriorityInput!) {
    updateWorkflowPriority(input: $input) {
      tenantId
      workflowIds
    }
  }
`;

export const GET_SEGMENTS = gql`
  query ($tenantId: ID!) {
    segments(tenantId: $tenantId) {
      id
      tenantId
      portfolioIds
      name
      default
    }
  }
`;

export const GET_WORKFLOW_COLLECTORS = gql`
  query ($tenantId: ID!) {
    searchCollectors(tenantId: $tenantId) {
      id
      name
      alias
      tenantId
      taxEntityId
      brandId
      serviceIds
      channelConfigIds
      eventHookConfigIds
      feedbackOptionIds
      paymentGatewayIds
    }
  }
`;

export const GET_LINKED_WORKFLOWS = gql`
  query ($id: ID!) {
    linkedWorkflows(id: $id) {
      id
      name
      type
    }
  }
`;
